import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import {Observable, of, switchMap} from 'rxjs';
import {UserService} from '../../user/user.service';
import {UserRole} from '../../user/user.types';

@Injectable({
    providedIn: 'root'
})
export class AdminGuard  {

    public constructor(
        private userService: UserService
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
        Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.userService.user$.pipe(
            switchMap(user => of(user.role === UserRole.admin))
        );
    }

}
